import * as React from "react";
import axios from "axios";
import { IPositionDetails } from "../../Requisitions/CreateRequisition/models/IPositionDetails";
import { convertShiftDateTime } from "../../ReusableComponents";
import { calculateBudget, currencyFormatter, dateFormatter } from "../../../HelperMethods";
import auth from "../../Auth";
import { AppPermissions } from "../Constants/AppPermissions";
import { AuthRoleType, ServiceTypes, isRoleType, isVendorRoleType } from "../AppConstants";

export interface PositionDetailsProps {
    reqId: string;
    showTargetRate?: boolean;
    reqDetails: any;
}

export interface PositionDetailsState {
    reqPosition?: IPositionDetails;
    serviceCategoryId: string;
    billRate?: any;
    targetRate?: any;
    budget?: any;
    holidays: any;
}

class PositionDetails extends React.Component<PositionDetailsProps, PositionDetailsState> {
    constructor(props: PositionDetailsProps) {
        super(props);
        this.state = {
            reqPosition: { reqId: "" },
            serviceCategoryId : "",
            holidays: []
        };
    }
    private userObj: any = JSON.parse(localStorage.getItem("user"));

    componentDidMount() {
        this.getPositionDetails(this.props.reqId);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.reqDetails?.reqId !== this.props.reqDetails?.reqId) {
            this.getServiceCategories();
        }
    }

    getServiceCategories = () => {
        axios.get(`api/candidates/servicecat?$filter=name eq 'Time'`).then((res) => {
            this.setState({ serviceCategoryId: res.data[0].id }, () => {
                this.getServiceTypes();
            });
        });
    }

    getServiceTypes = () => {
        const { serviceCategoryId } = this.state;

        if (this.props.reqDetails != undefined && this.props.reqDetails != null) {
            axios.get(`api/candidates/servicetype?serviceCatId=${serviceCategoryId}&clientId=${this.props.reqDetails.clientId}&divisionId=${this.props.reqDetails?.clientDivisionId}&locationId=${this.props.reqDetails?.divisionLocationId}&positionId=${this.props.reqDetails?.jobPositionId}`).then((res) => {
                let data = res.data.filter((i) => i.name === ServiceTypes.REGULARHOURS);
                if(data){
                    let maxBillrate = this.props.showTargetRate == true ? data[0].targetRate : data[0].billRate;
                    let targetrate = data[0].targetRate;
                    const reqPosition = {
                        billRate: maxBillrate,
                        targetRate: targetrate
                    };

                    this.setState({...reqPosition}, () => this.getHolidays(this.props.reqDetails?.clientId));
                }
            })
        }
    }

    updateBudget = (e?: any) => {
        const { reqPosition, billRate} = this.state;

        const data = {
            billRate,
            startDate: reqPosition.startDate,
            endDate: reqPosition.endDate,
            shiftStartTime: reqPosition.shiftStartTime,
            shiftEndTime: reqPosition.shiftEndTime,
            noOfReqStaff: reqPosition.noOfReqStaff
        };
        if (reqPosition?.startDate && reqPosition?.endDate && new Date(reqPosition.startDate).getFullYear() != new Date(reqPosition.endDate).getFullYear()) {
            axios.get(`api/clients/${this.props.reqDetails.clientId}/holidays?startDate=${new Date(reqPosition.startDate).toDateString()}&endDate=${new Date(reqPosition.endDate).toDateString()}`).then((res) => {
                const budget = calculateBudget(data, res.data);
                const reqPosition = {
                    budget: budget,
                };
                this.setState({...reqPosition})
            });
        }
        else {
            const budget = calculateBudget(data, this.state.holidays);
            const reqPosition = {
                budget: budget,
            };
            this.setState({...reqPosition})
        }
    };

    getHolidays(clientId, startDate?, endDate?) {
        axios.get(`api/clients/${clientId}/holidays`).then((res) => {
            this.setState({ holidays: res.data }, () => { this.updateBudget(); });
        });
    }

    //gets position details based on reqId
    getPositionDetails(reqId: string) {
        axios.get(`api/requisitions/${reqId}/position`).then((res:any) => {
            const reqPosition = { ...res.data };
            this.setState({ reqPosition: reqPosition });
        });
    }

    render() {
        const { reqPosition, targetRate, budget } = this.state;

        return (
            <div>
                {this.state.reqPosition.reqPositionId && (
                    <div className="mb-3">
                        <div className="row text-dark">
                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Job Workflow:</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{reqPosition.jobWf ? reqPosition.jobWf.name :"-"}</div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Job Category :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{reqPosition.jobCategory ? reqPosition.jobCategory.name :"-"}</div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Position :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{reqPosition.jobPosition ?reqPosition.jobPosition.name : "-"}</div>
                                </div>
                            </div>
                        {/* </div>
                        <div className="row text-dark mt-md-3 mt-2"> */}
                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Position Skills :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">
                                        {reqPosition.positionSkillMapping.map((x) => x.name).join(",")}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Position Description :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{reqPosition.positionDesc}</div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Positions Required :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{reqPosition.noOfReqStaff}</div>
                                </div>
                            </div>
                        {/* </div>
                        <div className="row text-dark mt-md-3 mt-2"> */}
                            {!isRoleType(AuthRoleType.Vendor) &&
                                <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                    <div className="row">
                                        <div className="col-6 text-right">Hiring Manager :</div>
                                        <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{reqPosition.hiringManager ?reqPosition.hiringManager.name : "-"}</div>
                                    </div>
                                </div>}
                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Assignment Type :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{reqPosition.assignType ? reqPosition.assignType.name :"-"}</div>
                                </div>
                            </div>
                        {/* </div>

                        <div className="row text-dark mt-md-3 mt-2"> */}
                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Start Date :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{dateFormatter(new Date(reqPosition.startDate))}</div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">End Date :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div"> {dateFormatter(new Date(reqPosition.endDate))}</div>
                                </div>
                            </div>
                            {/* <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Bill Rate :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{currencyFormatter(reqPosition.billRate)}</div>
                                </div>
                            </div> */}
                        {/* </div>

                        <div className="row text-dark mt-md-3 mt-2"> */}
                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Start Time :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">
                                        {convertShiftDateTime(reqPosition.shiftStartTime)}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">End Time :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{convertShiftDateTime(reqPosition.shiftEndTime)}</div>
                                </div>
                            </div>
                            {(auth.hasPermissionV2(AppPermissions.REQ_CREATE) || auth.hasPermissionV2(AppPermissions.REQ_APPROVE) || auth.hasPermissionV2(AppPermissions.REQ_REJECT)) && (
                                <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                    <div className="row">
                                        <div className="col-6 text-right">Budget :</div>
                                        <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{budget ? currencyFormatter(budget) : "-"}</div>
                                    </div>
                                </div>
                            )}
                            {this.props.showTargetRate == true && (
                                <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                    <div className="row">
                                        <div className="col-6 text-right">Target Rate :</div>
                                        <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{targetRate ? currencyFormatter(targetRate) :"-"}</div>
                                    </div>
                                </div>
                            )}
                        {/* </div>
                        <div className="row text-dark mt-md-3 mt-2"> */}
                            <div className="col-12 col-sm-4 mt-md-3 mt-2">
                                <div className="row">
                                    <div className="col-6 text-right">Positions On Hold :</div>
                                    <div className="col-6 font-weight-bold pl-0 text-left word-break-div">{reqPosition.noOfHoldStaff || "-"}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default PositionDetails;
